var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.003 0C8.104 0 9 .898 9 2.006L8.999 5H5.995A.997.997 0 0 0 5 6.01v1.98C5 8.549 5.456 9 5.995 9H9L9 11.994a2 2 0 0 1-1.848 2l-.15.006H1.998A2.003 2.003 0 0 1 0 11.994V2.006C0 .897.894 0 1.997 0ZM12 3l3.653 3.321a.897.897 0 0 1 0 1.358L12 11h-.508a.99.99 0 0 1-.993-.992V9.5L12.633 8h-5.63a.995.995 0 0 1-.996-.883L6 7l.007-.117A1 1 0 0 1 7.003 6h5.631L10.5 4.5v-.508c0-.548.442-.992.993-.992z"
})));
export default SvgMove;